import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { observer } from 'mobx-react';

import messages from './InfoAboutCompanyView.intl';
import styles from './InfoAboutCompanyView.module.scss';

import { Container, Title } from 'common/components/Layout/Layout';
import ImageGreyBackground from 'common/components/ImageGreyBackground/ImageGreyBackground';
import Document from 'common/components/Document/Document';

import ContentStore from 'stores/Content.store';
import InjectMetaTags from 'common/components/InjectMetaTags/InjectMetaTags';

import Placeholder from 'common/components/Placeholder/Placeholder';
import FullWidthBackground from 'common/components/Placeholder/components/FullWidthBackground/FullWidthBackground';
import ReturnToInvestors from '../../common/components/ReturnToInvestors/ReturnToInvestors';

@injectIntl
@observer
export default class InfoAboutCompanyView extends Component {
  render() {
    const content = ContentStore.content;
    return (
      <div>
        {ContentStore.isLoaded && (
          <InjectMetaTags {...content.corporateGovernanceSEO} />
        )}
        <Container>
          <Title title={this.props.intl.formatMessage(messages.heading)} />
        </Container>
        <Container>
          <ReturnToInvestors />
        </Container>
        <Placeholder component={<FullWidthBackground />} ready={!!content}>
          {content && (
            <ImageGreyBackground
              className={styles.BoldHeading}
              source={content.infoAboutCompanyImage}
              alternative="hello"
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: content.infoAboutCompanyText
                }}
              />
            </ImageGreyBackground>
          )}
        </Placeholder>
        {content && (
          <Container>
            <div className={styles.InfoAboutCompanyContent}>
              <p>{content.infoAboutCompanyHeader}</p>
              {content.infoAboutCompanyFiles.map(item => (
                <Document key={item.system.id} document={item} />
              ))}
            </div>
          </Container>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/InfoAboutCompany/InfoAboutCompanyView.js